import {Routes} from '@angular/router';
import {IndexComponent as TeamMemberIndexComponent} from '../team-members/index/index.component';
import {EditComponent as TeamMemberEditComponent} from '../team-members/edit/edit.component';
import {TeamMemberService} from '../../../services/api/administration/team-member.service';
import {canActivateGuard} from '../../../guards/can-activate-guard';
import {PERMISSION} from '@generated-backend-types';

export const routes: Routes = [
  {
    path: '',
    component: TeamMemberIndexComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_TEAMMEMBER_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.team-members.index.breadcrumb',
          translate: true,
          route: '/administration/team-members'
        },
      ]
    }
  },
  {
    path: 'add',
    component: TeamMemberEditComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_TEAMMEMBER_CREATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.team-members.index.breadcrumb',
          translate: true,
          route: '/administration/team-members'
        },
        {label: 'authenticated.administration.team-members.create.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id',
    component: TeamMemberEditComponent,
    canActivate: [canActivateGuard],
    resolve: {
      teamMember: TeamMemberService,
    },
    data: {
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_TEAMMEMBER_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.team-members.index.breadcrumb',
          translate: true,
          route: '/administration/team-members'
        },
        {dynamic: true, dataKey: 'teamMember.first_name,teamMember.last_name', route: '/administration/team-members/:id'},
        {label: 'authenticated.administration.team-members.edit.breadcrumb', translate: true,},
      ]
    }
  }
];
